export async function checkGeolocationStatus() {
  if (!('geolocation' in navigator)) {
    return { allowed: false, message: 'Por favor actualice su navegador.' };
  }

  try {
    if (navigator.permissions) {
      const { state } = await navigator.permissions.query({
        name: 'geolocation',
      });

      if (state === 'granted') {
        const coords = await getCurrentPosition();
        return { allowed: true, coords };
      }

      if (state === 'denied') {
        return {
          allowed: false,
          message:
            'Para continuar debe dar permisos al navegador para acceder a su ubicación.',
        };
      }

      if (state === 'prompt') {
        try {
          const coords = await getCurrentPosition({ promptMode: true });
          return { allowed: true, coords };
        } catch {
          return {
            allowed: false,
            message:
              'Para continuar debe dar permisos al navegador para acceder a su ubicación.',
          };
        }
      }

      return {
        allowed: false,
        message:
          'Por favor active la geolocalización de su navegador para iniciar sesión.',
      };
    }

    const coords = await getCurrentPosition();
    return { allowed: true, coords };
  } catch {
    return {
      allowed: false,
      message: 'Error al obtener permisos o coordenadas',
    };
  }
}

export async function getCurrentPosition({ promptMode = false } = {}) {
  return new Promise((resolve, reject) => {
    const options = promptMode
      ? { enableHighAccuracy: true, timeout: Infinity, maximumAge: 0 }
      : { timeout: 20000 };

    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      (err) => reject(err),
      options
    );
  });
}
